import React, {createContext, useContext, useMemo, useState} from 'react';

import {CurrentPageBySectionRefID} from '../../util/panelbankFlow';

type PanelBankSectionsPagingContextValue = {
  currentPageBySectionRefID: CurrentPageBySectionRefID;
  setCurrentPageForSectionRefID(
    sectionRefID: string,
    currentPage: number
  ): void;
};
type PanelBankSectionsPagingContextProviderProps = {
  children: React.ReactNode;
};

export const PanelBankSectionsPagingContext = createContext<
  PanelBankSectionsPagingContextValue | undefined
>(undefined);

export const PanelBankSectionsPagingContextProvider = ({
  children,
}: PanelBankSectionsPagingContextProviderProps) => {
  const [currentPageBySectionRefID, setCurrentPageBySectionRefID] =
    useState<CurrentPageBySectionRefID>({});

  const value = useMemo<PanelBankSectionsPagingContextValue>(
    () => ({
      currentPageBySectionRefID,
      setCurrentPageForSectionRefID: (sectionRefID, currentPage) =>
        setCurrentPageBySectionRefID(prev => {
          if (prev[sectionRefID] === currentPage) {
            return prev;
          }
          return {
            ...prev,
            [sectionRefID]: currentPage,
          };
        }),
    }),
    [currentPageBySectionRefID]
  );

  return (
    <PanelBankSectionsPagingContext.Provider value={value}>
      {children}
    </PanelBankSectionsPagingContext.Provider>
  );
};

export const usePanelBankSectionsPagingContext =
  (): PanelBankSectionsPagingContextValue => {
    const value = useContext(PanelBankSectionsPagingContext);
    if (value == null) {
      throw new Error(
        'usePanelBankSectionsPagingContext must be used within a PanelBankSectionsPagingContextProvider'
      );
    }
    return value;
  };
